/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getSubscriptionExposedApiState } from '../fn/exposed-api/get-subscription-exposed-api-state';
import { GetSubscriptionExposedApiState$Params } from '../fn/exposed-api/get-subscription-exposed-api-state';
import { SubscriptionExposedApi } from '../models/subscription-exposed-api';
import { upsertSubscriptionExposedApiState } from '../fn/exposed-api/upsert-subscription-exposed-api-state';
import { UpsertSubscriptionExposedApiState$Params } from '../fn/exposed-api/upsert-subscription-exposed-api-state';


/**
 * All about the exposed API configuration
 */
@Injectable({ providedIn: 'root' })
export class ExposedApiService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSubscriptionExposedApiState()` */
  static readonly GetSubscriptionExposedApiStatePath = '/custom/subscriptions/{uid}/exposed-api/state';

  /**
   * Get a subscription exposed API state.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptionExposedApiState()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionExposedApiState$Response(params: GetSubscriptionExposedApiState$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionExposedApi>> {
    return getSubscriptionExposedApiState(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a subscription exposed API state.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSubscriptionExposedApiState$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubscriptionExposedApiState(params: GetSubscriptionExposedApiState$Params, context?: HttpContext): Observable<SubscriptionExposedApi> {
    return this.getSubscriptionExposedApiState$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionExposedApi>): SubscriptionExposedApi => r.body)
    );
  }

  /** Path part for operation `upsertSubscriptionExposedApiState()` */
  static readonly UpsertSubscriptionExposedApiStatePath = '/custom/subscriptions/{uid}/exposed-api/state';

  /**
   * Upsert a subscription exposed API state.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertSubscriptionExposedApiState()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertSubscriptionExposedApiState$Response(params: UpsertSubscriptionExposedApiState$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionExposedApi>> {
    return upsertSubscriptionExposedApiState(this.http, this.rootUrl, params, context);
  }

  /**
   * Upsert a subscription exposed API state.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertSubscriptionExposedApiState$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertSubscriptionExposedApiState(params: UpsertSubscriptionExposedApiState$Params, context?: HttpContext): Observable<SubscriptionExposedApi> {
    return this.upsertSubscriptionExposedApiState$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubscriptionExposedApi>): SubscriptionExposedApi => r.body)
    );
  }

}
